import type { Theme } from '../../types/theme';

export const azureTheme: Theme = {
  id: 'azure',
  name: 'Azure',
  description: 'Cloud-native blue gradients for Microsoft cloud platform',
  sourceDesignMd: 'https://github.com/VoltAgent/awesome-design-md/blob/main/design-md/azure/DESIGN.md',
  visualKeywords: ['blue gradient', 'cloud', 'Microsoft', 'enterprise', 'infrastructure'],
  colors: {
    background: '#ffffff',
    surface: '#f3f3f3',
    surfaceElevated: '#f3f3f3',
    textPrimary: '#000000',
    textSecondary: '#666666',
    textMuted: '#666666',
    border: '#e0e0e0',
    borderSubtle: '#d6d6d6',
    primary: '#0078d4',
    primaryHover: '#1a86d9',
    primaryActive: '#0066b8',
    accent: '#0078d4',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'medium',
    tone: 'professional',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
